// extracted by mini-css-extract-plugin
module.exports = {"card":"InfluencerLoginUI__card___34IBJ","button":"InfluencerLoginUI__button___LXjPI","logo":"InfluencerLoginUI__logo___2NlQy"};